export default __webpack_public_path__ + "static/GRID22-map-disasters-c7aa18e00ba802d585ac71b5aeaa9e26.png";